import { Breadcrumb, Button } from "antd";
import { useEffect, useState } from "react";
import TonalStatistic from "../components/TonalStatistic";
import CompanyInfo from "../components/company-info/company-info";
import Experts from "../components/Experts";
import { StructureGraph } from "../components/StructureGraph/graphComponent";
import { useNavigate } from "react-router-dom";
import NumberOfMentions from "../components/NumberOfMentions";
import BanksInfo from "../components/banks-info/banks-info";
import PostsThread from "../components/PostsThread";
import BankBlocks from "../components/BankBlocks";
import RequestsTable from "../components/RequestsTable";
import Competitors from "../components/Competitors";

const Factory = () => {
  const [current, setCurrent] = useState<number>(0);
  let type = localStorage.getItem("usertype");
  const navigate = useNavigate();

  useEffect(() => {
    setCurrent(+window.location.pathname.split("/")[2]);
  }, []);

  return (
    <div className="App">

      {/*type != "customer" && (
        <div className="btn-group">
          <Button
            onClick={() => {
              navigate("/factory");
            }}
          >
            Все предприятия
          </Button>
        </div>
          )*/}

      <CompanyInfo current={+current} />
      <div className="grid2 light-block">
        <RequestsTable />
        <Competitors />
      </div>
      <BankBlocks />
      <BanksInfo />

      <TonalStatistic />
      <PostsThread />
      {type == "admin" && <NumberOfMentions />}
      {type == "admin" && <Experts />}
      {type == "admin" && <StructureGraph />}
    </div>
  );
};

export default Factory;
